import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import useNotifications from "@notifications";

export default function useUsersList() {
  // Use toast
  const { toastNotification } = useNotifications();

  const refUserListTable = ref(null);

  const styleColumns = {
    thClass: "text-center",
    tdClass: "text-center",
  };

  // Table Handlers
  let tableColumns = [
    {
      key: "fullName",
      sortable: true,
      label: "USUARIO",
      thClass: styleColumns.thClass,
    },
    {
      key: "email",
      sortable: true,
      label: "E-MAIL",
      ...styleColumns,
    },
    {
      key: "role_alias",
      sortable: true,
      label: "ROL",
      ...styleColumns,
    },
    {
      key: "department_name",
      sortable: true,
      label: "ÁREA",
      ...styleColumns,
    },
    {
      key: "status",
      sortable: true,
      label: "ESTADO",
      ...styleColumns,
    },
    { key: "actions", sortable: false, label: "OPCIONES", ...styleColumns },
  ];

  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  const fetchUsers = (ctx, callback) => {
    store
      .dispatch("app-user/fetchUsers", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { users, total } = response.data;
        callback(users);
        totalUsers.value = total;
      })
      .catch(() => {
        toastNotification("Error al obtener la lista de usuarios", false);
      });
  };

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    refetchData,
  };
}
